import { Pipe, PipeTransform } from '@angular/core'
import * as moment from 'moment'

@Pipe({ name: 'customDate' })
export class CustomDatePipe implements PipeTransform {
    transform(value: any, format: string): string {
        if (value) {
            if (value._seconds) {
                return moment(value._seconds * 1000).format(format)
            }
            if (value.seconds) {
                return moment(value.seconds * 1000).format(format)
            }
            return moment(value).format('D MMM YYYY')
        }
        return ''
    }
}
